import { render, staticRenderFns } from "./NavDesktopSidebar.vue?vue&type=template&id=97595d3a&"
import script from "./NavDesktopSidebar.vue?vue&type=script&lang=js&"
export * from "./NavDesktopSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports